import Message from '@sats-group/fresh-fitness-ui-lib/react/message';
import Text from '@sats-group/fresh-fitness-ui-lib/react/text';
import cn from 'classnames';
import React from 'react';

import ContentContainer from 'root/client/components/content-container/content-container';
import Logo from 'root/client/components/logo/logo';
import Progress from 'root/client/components/progress/progress';
import SalesLoader from 'root/client/components/sales-loader/sales-loader';
import Swoop from 'root/client/components/swoop/swoop';
import { salesFlow } from 'root/microcopy/sales-flow';

import { type SalesLayout as Props, themes } from './sales-layout.types';

const SalesLayout: React.FC<React.PropsWithChildren<Props>> & {
  themes: typeof themes;
} = ({
  children,
  dynamicMessages,
  isLoading = false,
  logo,
  messages,
  progress,
  theme,
  title,
}) => (
  <div
    className={cn('sales-layout', {
      [`sales-layout--${theme}`]: theme,
    })}
  >
    {theme === themes.confirmation ? (
      <Swoop className="sales-layout__background" />
    ) : null}
    {isLoading ? (
      <div
        className="sales-layout__loading"
        role="status"
        aria-label={salesFlow.loading}
      >
        <SalesLoader />
      </div>
    ) : null}
    <header className="sales-layout__header" inert={isLoading}>
      {title ? (
        <Text className="sales-layout__title" elementName="h1">
          {title}
        </Text>
      ) : null}
      <div className="sales-layout__logo">
        <Logo
          {...logo}
          theme={
            theme === themes.confirmation
              ? Logo.themes.White
              : Logo.themes.DarkRed
          }
        />
      </div>
      {progress ? <Progress {...progress} /> : null}
    </header>
    <div className="sales-layout__body" inert={isLoading} aria-busy={isLoading}>
      {messages.length || dynamicMessages.length ? (
        <ContentContainer width={ContentContainer.widths.Narrow}>
          <div className="sales-layout__messages">
            {messages.map(entry => (
              <div key={entry.text}>
                <Message {...entry} />
              </div>
            ))}
            {dynamicMessages.map(entry => (
              <div key={entry.text}>
                <Message {...entry} />
              </div>
            ))}
          </div>
        </ContentContainer>
      ) : null}
      <div className="sales-layout__content">{children}</div>
    </div>
  </div>
);

SalesLayout.themes = themes;

export default SalesLayout;
